import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client'
import createConfig from './bootstrap/createConfig.js';
import App from './App.jsx';

const { environment } = createConfig();

// render in strict mode in non-production environments
createRoot(document.getElementById('root')).render(
  environment !== 'production' ? <StrictMode>{App}</StrictMode> : App
);